import { useState, useEffect } from "react";
import { API } from "@/App";

/**
 * Environment Badge Component
 * Displays a visual indicator showing whether the app is running in
 * PREVIEW or PRODUCTION environment.
 * 
 * Positioned fixed in top-right corner, only visible when NOT in production.
 */
const EnvironmentBadge = () => {
  const [envInfo, setEnvInfo] = useState(null);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const fetchEnvInfo = async () => {
      try {
        const response = await fetch(`${API}/environment`);
        const data = await response.json();
        setEnvInfo(data);
      } catch (error) {
        console.error("Failed to fetch environment info:", error);
      }
    };
    fetchEnvInfo();
  }, []);

  // Don't show in production or if not loaded
  if (!envInfo || envInfo.is_production) {
    return null;
  }

  if (!isVisible) {
    return (
      <button
        onClick={() => setIsVisible(true)}
        className="fixed top-2 right-2 z-[9999] px-2 py-1 text-xs font-mono bg-amber-500 text-white rounded opacity-50 hover:opacity-100 transition-opacity"
        title="Show environment badge"
      >
        ENV
      </button>
    );
  }

  return (
    <div className="fixed top-2 right-2 z-[9999] flex flex-col items-end gap-1">
      {/* Main Badge */}
      <div className="flex items-center gap-2 px-3 py-1.5 bg-amber-500 text-white text-xs font-bold rounded-lg shadow-lg border border-amber-600">
        <span className="relative flex h-2 w-2">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-white"></span>
        </span>
        <span className="uppercase tracking-wider">
          {envInfo.environment === "development" ? "PREVIEW" : envInfo.environment}
        </span>
        <button
          onClick={() => setIsVisible(false)}
          className="ml-1 hover:bg-amber-600 rounded px-1"
          title="Hide badge"
        >
          ×
        </button>
      </div>
      
      {/* Expandable Details (on hover) */}
      <div className="group">
        <div className="hidden group-hover:block px-2 py-1 bg-gray-900 text-gray-300 text-[10px] font-mono rounded shadow-lg max-w-[200px]">
          <div>db: {envInfo.db_name}</div>
          <div>host: {envInfo.mongo_host_masked}</div>
          <div>build: {envInfo.build}</div>
        </div>
      </div>
    </div>
  );
};

export default EnvironmentBadge;
